import { z } from 'zod';
import { makeHtmlNodeParser, allHtmlParsers, xml2ast, makeAllHtmlParser } from '@utils/ast';
import { expandSelfClosingTags } from '@utils/common';
import { mediaSchema } from '../../media.js';
import { baseTaskSchema } from '../schema.base.js';
import { video23AudioInput } from './parser.audio.js';
import { video23Input } from './parser.video.js';

const infoPageTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("InfoPage"),
  media: z.array(mediaSchema).default([]),
  text: z.string()
}).transform(({
  media,
  text,
  ...rest
}) => {
  const parseHtmlNode = makeHtmlNodeParser(() => ({
    img: (node, context) => {
      const parsed = allHtmlParsers.img(node, context);
      if (!parsed) {
        return parsed;
      }
      const relatedMedia = media.find(it => it.type === "Image" && it.src === parsed?.attributes?.["src"]);
      if (!relatedMedia) {
        return null;
      }
      parsed.attributes ??= {};
      parsed.extra ??= {};
      parsed.attributes["alt"] = relatedMedia.altText ?? "";
      parsed.extra["longDesc"] = relatedMedia.longDescription;
      return parsed;
    }
  }));
  return {
    ...rest,
    content: xml2ast(expandSelfClosingTags(text), {
      ...allHtmlParsers,
      ...makeAllHtmlParser(parseHtmlNode),
      ...video23AudioInput.parsers,
      ...video23Input.parsers
    }, "text/html", {
      context: {
        taskId: rest.id,
        media
      }
    })
  };
});

export { infoPageTaskSchema };
//# sourceMappingURL=_schema.js.map
